import type { Rule } from '../types';
import { aboutRules } from './about';
import { completenessRules } from './completeness';
import { experienceRules } from './experience';
import { headlineRules } from './headline';
import { skillsRules } from './skills';

/**
 * The rule registry — the single list the engine walks.
 *
 * Adding a rule means adding it to its section's module; adding a whole new
 * section means one import and one spread here. There is deliberately no
 * auto-discovery or decorator magic: a contributor can read this file and know
 * exactly what runs.
 */
export const RULES: readonly Rule[] = [
  ...headlineRules,
  ...aboutRules,
  ...experienceRules,
  ...skillsRules,
  ...completenessRules,
];

/** Rule ids, exported for the "every rule is tested" coverage test. */
export const RULE_IDS: readonly string[] = RULES.map((rule) => rule.id);
